module.exports = __webpack_public_path__ + "img/logo_pressalit.0cbd5ed2.png";